import { HttpClient } from '@angular/common/http';
import { Component } from '@angular/core';
import { ItemRewardBoxIF } from './item-reward-box.interface';
import { AlertService } from 'src/app/services/alert.service';

@Component({
  selector: 'app-item-reward-box',
  templateUrl: './item-reward-box.component.html',
  styleUrls: ['./item-reward-box.component.scss']
})
export class ItemRewardBoxComponent {
  constructor(private http: HttpClient,
    private alert: AlertService
  ) {
    this.getItemsRewardBox();
  }
  itemRewardBox!: ItemRewardBoxIF[];
  getItemsRewardBox() {
    this.http.get(`itemRewardBox/25BCBFAC-6FC1-415B-8FB6-040490521272`).subscribe({
      next: (res: any) => {
        this.itemRewardBox = res.data
      }
    })
  }

  itemUsed(item: ItemRewardBoxIF) {
    this.http.get(`itemRewardBox/code/${item.ItemId}`).subscribe({
      next: (res: any) => {
        this.getItemsRewardBox();
      }
    })
  }

  useCode(code: any) {
    let model = {
      Code: code.value,
      OgId: '6e56a90e-e92d-4b3a-9df9-f53eab3c6d32'
    }
    this.http.put(`itemRewardBox/used`, model).subscribe({
      next: (res: any) => {
        this.alert.notify(res.message, 'success')
        this.getItemsRewardBox();
      },
      error: (err) => {
        this.alert.dialog(err.error.message)
      }
    })
  }
}
